const EXPERTS = {
  default: {
    name: '',
    photoUrl: 'https://cdn.guuru.com/assets/logo/avatar.png',
  },
} as const;

// eslint-disable-next-line import/prefer-default-export
export { EXPERTS };
